const t = "styles-module__inputSeparator___iDBsh", a = {
  inputSeparator: t
};
export {
  a as default,
  t as inputSeparator
};
